"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PropertyCardDataWrapperMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _spaceMixin = require("../spaceMixin");
/** @class PropertyCardDataWrapperMixin */
/** @method */
var PropertyCardDataWrapperMixin = function PropertyCardDataWrapperMixin(props) {
  return (0, _styledToken.default)('PropertyCard.data.gap', function (columnGap) {
    return (0, _styledComponents.css)(["align-content:start;display:grid;grid-area:data;grid-column-gap:", ";grid-template-areas:'title title actions' 'body1 body1 body1' 'body2 body2 body2' 'body3 mls-logo mls-logo' 'additionalInfo additionalInfo additionalInfo';grid-template-columns:1fr min-content;justify-content:space-between;"], columnGap ? columnGap + "px" : (0, _spaceMixin.spaceMixin)('xs')(props));
  })(props);
};
exports.PropertyCardDataWrapperMixin = PropertyCardDataWrapperMixin;